import { Component, OnInit, SecurityContext } from '@angular/core';
import { FilterObject } from '../../shared/models/FilterObject';
import { InfoCenterFile } from '../../shared/models/InfoCenterFile';
import { User } from '../../shared/models/User';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { PagingResults } from '../../shared/models/PagingResult';
import { FileObject } from '../../shared/models/FileObject';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Utilities } from '../../shared/models/Utilities';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-info-center',
  templateUrl: './info-center.component.html',
  styleUrls: ['./info-center.component.css']
})
export class AdminInfoCenterComponent implements OnInit {
  FileList: InfoCenterFile[];
  CurUser: User;
  FilterList: FilterObject[];
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  safeFileURL: string;


  readonly PageSizeOptions: number[] = [5, 10, 20, 50];

  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  constructor(private global:GlobalService, private http:HttpService, public matDialog:MatDialog, private sanitizer:DomSanitizer, private router:Router) { }

  ngOnInit(): void {
    this.FilterList = [];
    this.PageIndex = 0;
    this.PageSize = 20;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      if (this.CurUser && this.CurUser != null) {
        this.LoadFiles();
      }
      else {
      }
    });
    
  }

  LoadFiles() {
    this.http.GetInfoCenterFilesForAdmin(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize).then(wrap => {
      if (wrap.StatusCode == "200") {
        var pageResult = <PagingResults>wrap.Content;
        this.FileList = pageResult.Items;
        this.ItemCount = pageResult.ItemCount;
      }
    });
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "60%";
    dialogConfig.width = "85%";

    return dialogConfig;
  }


  AddNewFile(): void {
    var dialogConfig = this.GetDialogConfig("NewFile");
    dialogConfig.height = "60%";
    dialogConfig.width = "40%";
    var newFileObj = {
      type: 'addinfocenterfile'
    };
    dialogConfig.data = new InfoCenterFile();
    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);
    //this.CurrentOpenDialog.componentInstance.AddNewFileComp.SetNewFile(new InfoCenterFile());

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.UploadFile(event);
      this.CloseModal();
    });
  }

  UploadFile(newFile:InfoCenterFile) {
    if (newFile != null) {
      //do upload
      debugger;
      this.http.UploadInfoCenterFile(newFile, this.CurUser.UserId.toString()).then(x => {
        this.LoadFiles();
      });
    }
  }


  DeleteFile(fileID:string): void {
    this.http.DeleteInfoCenterFile(fileID).then(wrap => {
      if (wrap.StatusCode == "200") {
        this.LoadFiles();
      }      
    });
  }


  PreviewFile(file: InfoCenterFile) {
    debugger;


    this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), file.InfoCenterFileID).subscribe(({ body, headers }: HttpResponse<any>) => {
      debugger;
      var contentType = Utilities.GetContentType(file.FileType ?? file.FileName.substring(file.FileName.indexOf(".") + 1));
      const blob = new Blob([body], { type: contentType });
      var fileURL = URL.createObjectURL(blob);
      
      //window.open(fileURL, '_blank');
      var a = document.createElement("a");
      this.safeFileURL = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustUrl(fileURL));
      a.href = this.safeFileURL;
      a.target = "_blank";
      a.download = file.FileName;
      a.click();
    });
  }



  DownloadFile(file: InfoCenterFile) {
    this.http.DownloadInfoCenterFile(this.CurUser.UserId.toString(), file.InfoCenterFileID).subscribe(({ body, headers }: HttpResponse<any>) => {
      debugger;
      var contentType = headers.get('content-type');
      const blob = new Blob([body], { type: contentType });
      var fileURL = URL.createObjectURL(blob);
      
      var a = document.createElement("a");
      a.href = fileURL;
      a.download = file.FileName;
      a.click();

    });
  }

  PageEvent(event:any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadFiles();
  }

  CloseModal() {
    this.CurrentOpenDialog.close();
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.removeAllListeners();
    this.CurrentOpenDialog = null;
  }
}
